













































import { Component, Vue } from 'vue-property-decorator';

import { ResponseCodeEnum, DeliveryDateModel, TireStoringContract, TotalRemain, Utils } from '@/models';

import DeliveryDate from '@/components/delivery/DeliveryDate.vue';

// component
// @ts-ignore
import FunctionalCalendar from '@/components/calendar/FucntionCalendar.vue';

import { settingService, vehicleService } from '@/services';
import { Moment } from 'moment';

@Component({
    components: {
        FunctionalCalendar,
        DeliveryDate,
    },
})
export default class DeliveryCalendar extends Vue {
  private items: DeliveryDateModel[] = [];
  private currentDate: Date = this.$moment().toDate();
  private monthNames: string[] = [];
  private preDisabledState: boolean = false;
  private nextDisabledState: boolean = false;
  private total: number = 0;
  private dayNames: string[] = [];
  private lstHoliday: Moment[] = [];

  private async created() {
    this.monthNames = this.$moment.months();
    this.dayNames = Utils.DATE_PICKER_LANG.days;
    this.preDisabledState = true;
    await settingService.get()
    .then((res) => {
      if(res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
        this.total = res.data.data.quantily;
      }
    });
  }

  private getListHoliday(): Promise<Moment[]> {
    return new Promise((resolve, reject) => {
      vehicleService.getAllHoliday()
        .then((res: any) => {
          const lstDate: Moment[] = [];
          res.data.data.forEach((item: any) => {
            lstDate.push(this.$moment(item));
          });
          resolve(lstDate);
        });
    });
  }

  private getAllDateOfWeek(startOfWeek: any) {
    const endOfWeek = startOfWeek.clone().add(13, 'd');

    var zone_name =  this.$moment.tz.guess();
    startOfWeek.tz(zone_name);
    endOfWeek.tz(zone_name);
    
    vehicleService.getTotalDeliverySetRemain(startOfWeek.format("YYYY-MM-DD"), endOfWeek.format("YYYY-MM-DD"))
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.items = [];
          res.data.data.forEach((remain: TotalRemain, index) => {
            // const currentDate = this.$moment(remain.date).toDate();
            const currentDate = this.$moment(remain.date);
            const dateDeadline = this.$moment(remain.dateDeadlineWarehouse).toDate();
            
            this.items.push(new DeliveryDateModel({
              // dateNumber: currentDate.getDate(),
              dateNumber: currentDate.format("DD"),
              date: currentDate,
              totalDelivery: remain.total,
              isDelivery: true,
              id: index,
              isWorkOff: remain.isWorkOff,
              isAfter11h: remain.isAfter11h,
              dateDeadlineWarehouse: dateDeadline,
            }));
          });
        }
      });
  }

  private preMonth() {
    const crrDate = this.$moment().startOf('month');
    const preTemp = this.$moment().diff(this.$moment((this.$refs.Calendar as any).listCalendars[0].date), 'month');
    if(preTemp >= 0 || preTemp < -2) {
      this.preDisabledState = true;
    } else {
      if(preTemp < 0 || preTemp >= 1) {
        this.nextDisabledState = false;
      }
      this.preDisabledState = false;
    }
    (this.$refs.Calendar as any).PreMonth();
  }

  private nextMonth() {
    const crrDate = this.$moment().startOf('month');
    const nextTemp = this.$moment().diff(this.$moment((this.$refs.Calendar as any).listCalendars[0].date), 'month');
    if (nextTemp !== 0) {
      this.nextDisabledState = true;
    } else {
      if(nextTemp < -3 || nextTemp >= 0) {
        this.preDisabledState = false;
      }
      this.nextDisabledState = false;
    }
    (this.$refs.Calendar as any).NextMonth();
  }

  private async changeDate(data: any) {
    this.getDateTop();
    this.items = [];
    const date = !data.selectedDate ? this.currentDate : data.selectedDate;
    this.currentDate = date;
    this.getAllDateOfWeek(this.$moment(date, 'DD/MM/YYYY'));
    this.getListHoliday().then((res) => {
      (this.$refs.Calendar as any).pushVal([], res);
    });
  }
  
  private getDateTop() {
    if (this.$refs.Calendar as any) {
      (this.$refs.Calendar as any).listCalendars.forEach((element: any, index: number) => {
          (this.$refs.Calendar as any).listCalendars[index].dateTop = 
          this.$moment()
            .year((this.$refs.Calendar as any).listCalendars[index].date.getFullYear())
            .month((this.$refs.Calendar as any).listCalendars[index].date.getMonth())
          .format('YYYY 年 MMM');
      });
    }
  }
}
